const describeAppFundaViewingRequestNewCondition = (): string =>
  'een nieuw Funda bezichtigingsverzoek is opgevraagd';

export default describeAppFundaViewingRequestNewCondition;
